export default __webpack_public_path__ + "static/media/top_prospect.d64bcbff.svg";